import MarkdownLanguage from "./MarkdownLanguage";
import MarkdownLanguageConfiguration from "./MarkdownLanguageConfiguration";
export default function (options) {
    return {
        language: new MarkdownLanguage(options),
        conf: MarkdownLanguageConfiguration
    };
}
export * from "./schema/createSchema";
export { createMarkdownTools } from "./MarkdownLanguage";
export * from "./markdown/MarkdownParser";
export * from "./markdown/MarkdownSerializer";
export { default as MarkdownLanguage } from "./MarkdownLanguage";
